import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useFormContext, useController } from 'react-hook-form';
import { normaliseKey } from '../../lib/string';

const withFormContext = (WrappedComponent) => {
  function wrapper(props) {
    const [watching, setWatching] = useState(false);
    const { trigger, clearErrors, watch, handleSubmit } = useFormContext();
    const { name, defaultValue, rules = {}, onNext, autoSubmit = true } = props;

    // Escape the field name to be used as an HTML attribute.
    const normalisedName = normaliseKey(name);

    const { field, fieldState } = useController({
      name: normalisedName,
      defaultValue,
      rules,
    });

    // Validate on mount so the submit button state is up to date.
    useEffect(async () => {
      await trigger(normalisedName);
      clearErrors(normalisedName);
      props.onOptionsLoaded(field);
    }, []);

    // Watch for changes and auto submit.
    if (autoSubmit) {
      const value = watch(normalisedName, defaultValue);

      useEffect(() => {
        if (watching) {
          handleSubmit(onNext)();
        }
      }, [value]);

      setTimeout(() => setWatching(true));
    }

    return <WrappedComponent {...props} field={field} fieldState={fieldState} />;
  }

  wrapper.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    type: PropTypes.string,
    defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
    rules: PropTypes.shape(),
    onNext: PropTypes.func.isRequired,
    onOptionsLoaded: PropTypes.func.isRequired,
    autoSubmit: PropTypes.bool,
  };

  wrapper.defaultProps = {
    label: '',
    type: 'text',
    defaultValue: '',
    rules: {},
    validate: null,
    onOptionsLoaded: () => {},
  };

  return wrapper;
};

export default withFormContext;
